import actions from 'circe/listing/actions';
import actionTypes from './actionTypes';

export const {
  fetch, fetchNext, fetchPrev, fetched, fetching, cache,
} = actions(actionTypes);

export const markAsPaid = id => ({
  type: actionTypes.MARK_AS_PAID,
  payload: {
    id,
  },
});

export const markedAsPaid = id => ({
  type: actionTypes.MARKED_AS_PAID,
  payload: {
    id,
  },
});
